function requireEnv(key: string): string {
  const value = import.meta.env[key as keyof ImportMetaEnv];
  if (typeof value !== "string" || value.trim().length === 0) {
    throw new Error(`Missing required client environment variable: ${key}`);
  }
  return value.trim();
}

function requireBooleanEnv(key: string): boolean {
  const value = requireEnv(key).toLowerCase();
  if (value !== "true" && value !== "false") {
    throw new Error(`Environment variable ${key} must be "true" or "false"`);
  }
  return value === "true";
}

export const clientEnv = {
  apiUrl: requireEnv("VITE_API_URL"),
  clerkPublishableKey: requireEnv("VITE_CLERK_PUBLISHABLE_KEY"),
  forceAdminRouter: requireBooleanEnv("VITE_FORCE_ADMIN_ROUTER"),
  googlePlacesApiKey: requireEnv("VITE_GOOGLE_PLACES_API_KEY"),
  logoDevPublishableKey: requireEnv("VITE_LOGODEV_PUBLISHABLE_KEY"),
  nodeEnv: requireEnv("VITE_NODE_ENV"),
  posthogApiKey: requireEnv("VITE_POSTHOG_API_KEY"),
  posthogHost: requireEnv("VITE_POSTHOG_HOST"),
  theResumePublicUrl: requireEnv("VITE_THERESUME_PUBLIC_URL"),
} as const;
